// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2YO5V","title":"ClientCherryInfo_title__3ARuh","itemText":"ClientCherryInfo_itemText__1Insw"};